// src/components/Sidebar.jsx

import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faQrcode,
    faKey,
    faBars,
    faUser,
    faUsers,
    faPlus,
    faMoneyCheck,
    faSignOutAlt,
  } from '@fortawesome/free-solid-svg-icons';
import '../styles/Sidebar.css';
import { useLocation, Link, useNavigate } from 'react-router-dom';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const isActive = (path) => location.pathname === path;

  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.reload();
    navigate('/');
  };

  return (
    <>
      {/* Toggle Button for mobile view */}
      <button
        className={`sidebar-toggle ${isOpen ? 'open' : ''}`}
        onClick={toggleSidebar}
      >
        <FontAwesomeIcon icon={faBars} />
      </button>

      {/* Sidebar Navigation */}
      <div className={`sidebar ${isOpen ? 'sidebar-open' : ''}`}>
        <Nav className="flex-column">
          <Nav.Link as={Link} to="/" className={isActive('/') ? 'active' : ''}>
            <FontAwesomeIcon icon={faQrcode} className="me-4" />
            My QR Codes
          </Nav.Link>
          <Nav.Link as={Link} to="/create-qr" className={isActive('/create-qr') ? 'active' : ''}>
            <FontAwesomeIcon icon={faPlus} className="me-4" />
            Create New QR
          </Nav.Link>
          <Nav.Link as={Link} to="/group-users" className={isActive('/group-users') ? 'active' : ''}>
            <FontAwesomeIcon icon={faUsers} className="me-4" />
            Group Users
          </Nav.Link>
          <Nav.Link as={Link} to="/pricing" className={isActive('/pricing') ? 'active' : ''}>
            <FontAwesomeIcon icon={faMoneyCheck} className="me-4" />
            Pricing
          </Nav.Link>
          <Nav.Link as={Link} to="/profile" className={isActive('/profile') ? 'active' : ''}>
            <FontAwesomeIcon icon={faUser} className="me-4" />
            Profile
          </Nav.Link>
          <Nav.Link as={Link} to="/password" className={isActive('/password') ? 'active' : ''}>
            <FontAwesomeIcon icon={faKey} className="me-4" />
            Change Password
          </Nav.Link>
          <Nav.Link  onClick={handleLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} className="me-4" />
            LogOut
          </Nav.Link>
        </Nav>
      </div>
    </>
  );
};

export default Sidebar;
